import React from "react"

export default function Row({ index, email, firstName, lastName, phone, notes }) {
  return (
    <tr>
      <td>{index}</td>
      <td>{email}</td>
      <td>{firstName}</td>
      <td>{lastName}</td>
      <td>{phone}</td>
      <td
        title={notes || undefined}
        style={
          notes ? { maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } : undefined
        }>
        {notes || "—"}
      </td>
    </tr>
  )
}
